import 'client-only';

import cookies from 'js-cookie';
import Maybe from 'true-myth/maybe';
import { isBrand, matchBrandForHostname } from './index';
import type { Brand, HostnamePattern } from './index';

export { isBrand, isHotpads, isZillow } from './index';
export type { Brand, HostnamePattern } from './index';

export type GetBrandOptions = {
  hostnamePatterns?: Array<HostnamePattern>;
  fallback?: Brand;
  devCookieName?: string | false;
};

export function getBrand(options?: GetBrandOptions): Maybe<Brand> {
  if (typeof window === 'undefined') {
    return Maybe.of(options?.fallback);
  }

  const cookieOverride = typeof document !== 'undefined' ? cookies.get('MULTIBRAND_SUPPORT:brand') : undefined;
  if (isBrand(cookieOverride)) {
    return Maybe.of(cookieOverride);
  }

  const multibrandSupport = 'MULTIBRAND_SUPPORT' in window ? window['MULTIBRAND_SUPPORT'] : undefined;
  if (multibrandSupport != null && typeof multibrandSupport === 'object') {
    const brand = 'brand' in multibrandSupport ? multibrandSupport.brand : undefined;
    if (isBrand(brand)) {
      return Maybe.of(brand);
    }
  }

  if (options?.hostnamePatterns) {
    const brand = matchBrandForHostname(window.location.host, options.hostnamePatterns);
    if (brand.isJust) {
      return brand;
    }
  }

  const devCookieName = options?.devCookieName ?? 'dev_brand';
  if (devCookieName !== false && isDevelopmentEnvironment()) {
    const devBrand = cookies.get(devCookieName);
    if (isBrand(devBrand)) {
      return Maybe.of(devBrand);
    }
    return Maybe.of(options?.fallback);
  }

  return Maybe.of(options?.fallback);
}

function isDevelopmentEnvironment(): boolean {
  return window.location.host.includes('localhost') || process.env.NODE_ENV === 'development';
}
